import { useTranslation } from "react-i18next";
import { FieldWrapper } from "../fields";
import CampaignNameField from "./CampaignNameField";
import checkModule from "../../../../../utils/checkModule";
import { AD_TYPES } from "../constants";

const CampaignNames = ({ state, onChange, errors, fieldsToValidate, channel, review, modules, marketPlace }) => {
  const { t } = useTranslation(["advertising"]);
  if (
    !checkModule(modules, "CAMPAIGN_NAMES") ||
    (state.adType === AD_TYPES.SPONSORED_DISPLAY_V2.value && !state.sdCampaignType) ||
    state.canHaveChildren ||
    (review && !state.id) ||
    channel !== "amazon"
  ) {
    return null;
  }
  const { campaignNames } = state;

  const handleCampaignNameChange = (type, value) => {
    const updatedCampaignNames = { ...campaignNames, [type]: value };
    onChange({ campaignNames: updatedCampaignNames });
  };

  return (
    <FieldWrapper>
      <h2
        style={{
          fontWeight: 500,
          fontSize: "20px",
          marginTop: "1rem",
          marginLeft: "2rem",
        }}
      >
        {t(($) => $.advertising["Campaign Names"])}
      </h2>
      {!state.id ?
        <p
          style={{
            fontSize: "16px",
            marginBottom: "2rem",
            marginLeft: "2rem",
            maxWidth: "90%",
          }}
          translate="yes"
        >
          {t(($) => $.advertising["You can customize your campaign names using the fields below."])}
        </p>
      : null}
      {errors.campaignNames && fieldsToValidate?.includes("campaignNames") && (
        <small className="text-danger d-block pb-3" style={{ paddingLeft: "2rem" }}>
          {errors.campaignNames}
        </small>
      )}
      {errors.duplicateCampaignNames && fieldsToValidate?.includes("duplicateCampaignNames") && (
        <small className="text-danger d-block pb-3" style={{ paddingLeft: "2rem" }}>
          {errors.duplicateCampaignNames}
        </small>
      )}
      {Object.keys(campaignNames).map((campaignType) => (
        <CampaignNameField
          campaignType={campaignType}
          campaignName={campaignNames[campaignType]}
          state={state}
          handleCampaignNameChange={handleCampaignNameChange}
          key={`${campaignType}`}
          marketPlace={marketPlace.marketPlace}
        />
      ))}
    </FieldWrapper>
  );
};

export default CampaignNames;
